import React, { Fragment, memo, useContext, useEffect, useMemo, useState } from 'react'
import SideBarIcon from './SideBarIcon'
import { GetURLPath, IsListNotEmpty, toolTipAtrributes } from '@utils'
import { useTranslation } from 'react-i18next'
import DirectLink from './DirectLink'
import { CRRender } from '@comp/crRender'
import { PrivilegeContext } from '@context/PrivilegesContext'


const SubLink = ({ screen, handleNavigate, subOpendedScreens, isMenuOpened }) => {

    const { t } = useTranslation()

    const { authorizedPages } = useContext(PrivilegeContext)
    const { name, icon, id, path, children: childrenList } = useMemo(() => screen, [screen])
    const [isChildActive, setIsChildActive] = useState(false)

    useEffect(() => {
        const curretOpened = GetURLPath()
        const isListChild = IsListNotEmpty(childrenList?.filter(subSc => subSc.path == curretOpened))

        setIsChildActive(isListChild || (subOpendedScreens == path))
    }, [path, subOpendedScreens])


    return (
        <CRRender isRender={!!authorizedPages.find(p => id?.includes(p.id))?.id && IsListNotEmpty(childrenList)}>

            <div className='dropDownContainer pointer' activeclassname="active" key={name} >
                <li className={`${isChildActive ? "active" : ""} menu`}
                    onClick={() => handleNavigate(1, name)}
                    {...toolTipAtrributes(t(name), null, isMenuOpened)} >
                    <SideBarIcon icon={icon} />
                    <span className={`Item-name ${isMenuOpened ? "" : "d-none"}`}>{t(name)}</span>
                </li>

                <CRRender isRender={subOpendedScreens == name}>
                    <div className={"floated pointer"}>
                        {childrenList?.map(subScreen =>
                            <Fragment key={subScreen.id}>
                                <DirectLink screen={{ ...subScreen, id: [subScreen.id] }} handleNavigate={handleNavigate} />
                            </Fragment>
                        )}
                    </div>
                </CRRender>
            </div>

        </CRRender>

    )
}

export default memo(SubLink)